
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 2221","d":"M17.244 10.714l-9-5.2a1.487 1.487 0 00-2.23 1.289v2.95a1.145 1.145 0 001.03 1.138l4.684.463a.649.649 0 010 1.291l-4.684.469a1.143 1.143 0 00-1.03 1.133v2.949a1.487 1.487 0 002.23 1.288l9-5.2a1.487 1.487 0 000-2.575","fill":"currentColor"}})])
          )
        }
      }
    